<template>
  <div>
    <va-modal
      class="modal"
      v-model="showEdition"
      :okText="saveMessage"
      cancelText="Annuler"
      max-width="100%"
      v-on:ok="editPublication"
      v-on:cancel="closeModal"
      noEscDismiss
      noOutsideDismiss
      disabled
      title="Création d'une nouvelle publication"
    >
      <div class="forcewidth">
        <div class="row row-inside">
          <div class="flex md12">
            <div class="row row-inside">
              <div class="flex md2">
                <div class="numeroDisp-mod">
                  <va-input
                    class="input-t1"
                    type="number"
                    step="1"
                    :disabled="publication.hors_serie"
                    v-show="!publication.hors_serie"
                    v-model="publication.numero"
                  />
                  <va-date-picker
                    class="input-t1"
                    :config="{ dateFormat: 'd-m-Y' }"
                    v-model="publication.date_previsionnelle"
                  />
                </div>
              </div>
              <div class="flex md3 ma-1">
                <va-date-picker
                  label="Date de parution"
                  :config="{ dateFormat: 'd-m-Y' }"
                  v-model="publication.date_parution"
                />
              </div>
              <div class="flex md3 ma-1">
                <va-date-picker
                  label="Date Routage"
                  :config="{ dateFormat: 'd-m-Y' }"
                  v-model="publication.date_routage"
                />
              </div>
              <div class="flex md3 ma-1">
                <va-date-picker
                  label="Date de Réception"
                  :config="{ dateFormat: 'd-m-Y' }"
                  v-model="publication.date_reception"
                />
              </div>
              <div class="flex md2">
                <va-checkbox
                  v-model="publication.hors_serie"
                  label="hors-Série"
                />
              </div>
            </div>
            <div class="row row-inside mt-5">
              <div class="flex md6">
                <div class="flex md12">
                  <h4>Coût du numéro</h4>
                </div>
                <div class="flex md12 ma-2">
                  <va-input
                    label="Coût routage"
                    type="number"
                    v-model="publication.cout_routage"
                  />
                </div>
                <div class="flex md12 ma-2">
                  <va-input
                    label="Coût impression"
                    type="number"
                    v-model="publication.cout_impression"
                  />
                </div>
                <div class="flex md12 ma-2">
                  <va-input
                    label="Coût rédaction / conception"
                    type="number"
                    v-model="publication.cout_conception"
                  />
                </div>
              </div>
              <div class="flex md6"></div>
            </div>
          </div>
          <div class="flex md4"></div>
        </div>
      </div>
    </va-modal>
  </div>
</template>

<script>
import axios from "axios";
import moment from "moment";
import { cloneDeep, find, isEqual } from "lodash";

export default {
  name: "creation-publication",
  props: ["value"],
  data() {
    return {
      showEdition: false,
      publication: this.resetPublication(),
      publication_bak: this.resetPublication(),
    };
  },
  mounted() {
    this.resetValues();
    this.showEdition = this.value; // initialize internal variables
  },
  methods: {
    resetPublication() {
      return {
        idpublication: null,
        numero: null,
        date_creation: moment().format("YYYY-MM-DD"),
        date_parution: null,
        date_routage: null,
        date_reception: null,
        date_cloture: null,
        date_ouverture: null,
        cout_routage: null,
        cout_impression: null,
        produit_previsionnel_final: null,
        produit_effectif: null,
        cout_conception: null,
        diffusion_partenaires: null,
        diffusion_entreprises: null,
        listing: false,
        pdf: false,
        date_previsionnelle: moment().format("DD-MM-YYYY"),
        hors_serie: false,
        isactif: false,
      };
    },
    async editPublication() {
      this.showEdition = true;
      if (!this.$store.getters.user.publications_numeros) {
        this.launchEpicmaxToast("Droit insuffisant");
        return;
      }
      let publication_mod = cloneDeep(this.publication);

      //validate
      // check if HS or not and set the
      if (publication_mod.hors_serie) {
        publication_mod.numero = null;
      }

      // check that the numero is null or int
      console.log(publication_mod.numero);
      if (
        publication_mod.numero &&
        !Number.isInteger(parseInt(publication_mod.numero))
      ) {
        this.launchEpicmaxToast(
          "Le numéro de la publication doit être un entier."
        );
        return;
      }

      // check that all dates are valid and convert to YYYY-MM-DD
      // previsionnelle
      if (publication_mod.date_previsionnelle) {
        if (
          !moment(publication_mod.date_previsionnelle, "DD-MM-YYYY").isValid()
        ) {
          this.launchEpicmaxToast("Date prévisionnelle invalide");
          return;
        }
        publication_mod.date_previsionnelle = moment(
          publication_mod.date_previsionnelle,
          "DD-MM-YYYY"
        ).format("YYYY-MM-DD");
        console.log(publication_mod.date_previsionnelle);
      } else {
        publication_mod.date_previsionnelle = null;
      }

      // parution
      if (publication_mod.date_parution) {
        if (!moment(publication_mod.date_parution, "DD-MM-YYYY").isValid()) {
          this.launchEpicmaxToast("Date de parution invalide");
          return;
        }
        publication_mod.date_parution = moment(
          publication_mod.date_parution,
          "DD-MM-YYYY"
        ).format("YYYY-MM-DD");
        console.log(publication_mod.date_parution);
      } else {
        publication_mod.date_parution = null;
      }

      // routage
      if (publication_mod.date_routage) {
        if (!moment(publication_mod.date_routage, "DD-MM-YYYY").isValid()) {
          this.launchEpicmaxToast("Date de routage invalide");
          return;
        }
        publication_mod.date_routage = moment(
          publication_mod.date_routage,
          "DD-MM-YYYY"
        ).format("YYYY-MM-DD");
        console.log(publication_mod.date_routage);
      } else {
        publication_mod.date_routage = null;
      }

      // reception
      if (publication_mod.date_reception) {
        if (!moment(publication_mod.date_reception, "DD-MM-YYYY").isValid()) {
          this.launchEpicmaxToast("Date de parution invalide");
          return;
        }
        publication_mod.date_reception = moment(
          publication_mod.date_reception,
          "DD-MM-YYYY"
        ).format("YYYY-MM-DD");
        console.log(publication_mod.date_reception);
      } else {
        publication_mod.date_reception = null;
      }

      // check that the cost are valid floats
      // routage
      if (publication_mod.cout_routage) {
        console.log(publication_mod.cout_routage);
        publication_mod.cout_routage = Number(publication_mod.cout_routage);
        if (isNaN(publication_mod.cout_routage)) {
          this.launchEpicmaxToast(
            "Les couts de routages doivent être un nombre valide"
          );
          return;
        }
      } else {
        publication_mod.cout_routage = null;
      }
      // impression
      if (publication_mod.cout_impression) {
        console.log(publication_mod.cout_impression);
        publication_mod.cout_impression = Number(
          publication_mod.cout_impression
        );
        if (isNaN(publication_mod.cout_impression)) {
          this.launchEpicmaxToast(
            "Les couts d'impression doivent être un nombre valide"
          );
          return;
        }
      } else {
        publication_mod.cout_impression = null;
      }
      // redaction
      if (publication_mod.cout_conception) {
        console.log(publication_mod.cout_conception);
        publication_mod.cout_conception = Number(
          publication_mod.cout_conception
        );
        if (isNaN(publication_mod.cout_conception)) {
          this.launchEpicmaxToast(
            "Les couts de conception doivent être un nombre valide"
          );
          return;
        }
      } else {
        publication_mod.cout_conception = null;
      }
      try {
        await axios.put("/api/publications/create", {
          publication: publication_mod,
        });
        this.launchEpicmaxToast("Publication créée");
        this.$emit("creation", true);

        this.closeModal();
      } catch (error) {
        console.log(error);
        if (error.response) {
          this.launchEpicmaxToast(error.response.data);
        }
      }
    },
    resetValues() {
      //reset all values
      this.publication = this.resetPublication();
      if (!this.idnumero) {
        //creation
        this.createNew();
      }
    },
    async createNew() {
      try {
        let resTmp = await axios.get("api/publications/last-number");
        let tmpN = parseInt(resTmp.data.lastNumero);
        if (tmpN !== NaN) {
          this.publication.numero = tmpN + 1;
        }
        this.publication.date_creation = moment().format("YYYY-MM-DD");
        this.publication_bak = cloneDeep(this.publication);
      } catch (error) {
        this.launchEpicmaxToast(
          "Erreur lors de la communication avec le serveur"
        );
        console.log(error);
      }
    },
    closeModal() {
      this.resetValues();
      this.$emit("input", false);
    },
    launchEpicmaxToast(toast) {
      this.showToast(toast, {
        position: "bottom-center",
        duration: 5000,
      });
    },
  },
  computed: {
    saveMessage: function () {
      if (!this.idnumero) {
        return "Créer une nouvelle publication";
      }
      if (!isEqual(this.publication, this.publication_bak)) {
        return "Sauvegarder les modifications";
      } else {
        return "Fermer";
      }
    },
  },
  watch: {
    value() {
      // Parent property changed; update internal variables
      this.showEdition = this.value;
      this.resetValues();
    },
  },
};
</script>

<style lang="scss" scoped>
.forcewidth {
  width: 45vw;
  height: 75vh;
  overflow: auto;
}
.fullwidth {
  width: 95%;
}

.input-t1 {
  margin: 5px;
}
.numeroDisp-mod {
  background-color: $vue-green;
  //color: white;
  border: solid 1px $vue-green;
  width: 8em;
  height: 8em;
  span {
    outline: none !important;
  }
}
</style>
